global.LANG = LANG_CACHE;
global.LANG_CODE = LANG_CODE;